// https://firebase.google.com/docs/database/web/read-and-write
import all from './all';
import create from './create';
import read from './read';
import remove from './remove';
import update from './update';

export default {
  all,
  create,
  read,
  remove,
  update,
};
